import styled, { css } from 'styled-components'

const UpperComponentContainer = styled('div')`
  ${({ theme }) => css`
    margin-top: ${theme.spaces[1]};
    margin-bottom: ${theme.spaces[2]};
  `}
`
export default UpperComponentContainer
